import { default as authService } from './services/Auth/AuthService';

export default {
  authService,
};
